import { render, staticRenderFns } from "./QuoteDetailAssessmentSummary.vue?vue&type=template&id=fb855702&scoped=true"
import script from "./QuoteDetailAssessmentSummary.vue?vue&type=script&lang=js"
export * from "./QuoteDetailAssessmentSummary.vue?vue&type=script&lang=js"
import style0 from "./QuoteDetailAssessmentSummary.vue?vue&type=style&index=0&id=fb855702&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fb855702",
  null
  
)

export default component.exports